import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { Grid, Box,Card, CardContent, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import axiosInstance from '../utils/api';
import RegionBarChart from './blocks/RegionalBarChart';
import LenderDashboard from './blocks/LenderDashboard';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const Dashboard = () => {
    const [mtdAudits, setMtdAudits] = useState(null);
    const [mtdScores, setMtdScores] = useState(null);
    const [regionalAudits, setRegionalAudits] = useState(null);
    useEffect(() => {
        axiosInstance.get('/api/mi?type=estimated_monthly').then((response) => {
            setMtdAudits(response.data.results);
        })
        .catch((error) => {
        });
    }, []);

    useEffect(() => {
        axiosInstance.get('/api/mi?type=audits_by_region').then((response) => {
            setRegionalAudits(response.data.results);
        }
        ).catch((error) => {
        }
        );
    }, []);

    useEffect(() => {
        axiosInstance.get('/api/mi?type=mtd_results').then((response) => {
            setMtdScores(response.data.results);
        }
        ).catch((error) => {
        }
        );
    }, []);
  

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart Title',
            },
        },
    };

    // const mtdAudits = 1250; // Replace with dynamic data if needed
    const mtdPass = 12
    const mtdImprove = 2
    const mtdSignificantImprove = 10

    return (
        <Box sx={{ p: 3  }}>
            {mtdAudits && mtdScores ? (
                <>

                    <Grid container spacing={2} justifyContent="space-evenly">
                        {/* Card for MTD Pass */}
                        <Grid item xs={12} md={3}>
                            <Card sx={{ background: 'green', color: '#fff', textAlign: 'center' , cursor: 'pointer'}} onClick={() => window.location.href = '/view-all-audits/?pass=true'}>
                                
                                <CardContent>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        MTD Pass
                                    </Typography>
                                    <Typography variant="h4">{mtdScores.Pass}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        

                        {/* Card for MTD Improve */}
                        <Grid item xs={12} md={3}>
                            <Card sx={{ background: '#FFBF00', color: '#fff', textAlign: 'center' , cursor: 'pointer'}} onClick={() => window.location.href = '/view-all-audits/?improvement=true'}>
                                <CardContent>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        MTD Improvement Required
                                    </Typography>
                                    <Typography variant="h4">{mtdScores.Improvement_Required}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Card for MTD Significant Improve */}
                        <Grid item xs={12} md={3}>
                            <Card sx={{ background: 'red', color: '#fff', textAlign: 'center', cursor: 'pointer'}} onClick={() => window.location.href = '/view-all-audits/?significantImprovement=true'}>
                                <CardContent>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        MTD Significant Improvement Required
                                    </Typography>
                                    <Typography variant="h4">{mtdScores.Signigicant_Improvement_Required}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>


                    
                    <RegionBarChart results={regionalAudits} />

                    <LenderDashboard results={mtdAudits} />

                </>
            ) : (
                <Typography variant="h6" sx={{ textAlign: 'center', mt: 4 }}>
                    Loading...
                </Typography>
            )}

    
        </Box>
    );
};

export default Dashboard;
